// The machine card menu's own keys (#6785), shared by its main body
// (`components/machine-card/MissionCardMenu.tsx`) and its "Jobs at once" picker
// (`components/MachineJobsAtOnce.tsx`, #6740): ↑ ↓ wrap, Home and End jump, over every
// `menuitem` AND `menuitemradio` row of the menu element. The index step is
// `nextListboxIndex` (`./listbox-keys`), the one implementation; this adds only the DOM
// half and the "focus is outside the rows" start.

import { isListboxKey, nextListboxIndex } from './listbox-keys';

/** Every focusable row of a menu, in document order. */
const ROWS = '[role="menuitem"], [role="menuitemradio"]';

/**
 * Move focus for one navigation key. Answers whether the key was one (the caller then
 * prevents its default). With focus outside the rows, the first ↓ or Home lands on the
 * first row and the first ↑ or End on the last.
 */
export function moveMenuFocus(menu: HTMLElement, key: string): boolean {
  if (!isListboxKey(key)) return false;
  const items = [...menu.querySelectorAll<HTMLElement>(ROWS)];
  if (items.length === 0) return false;
  const active = document.activeElement;
  const at = active instanceof HTMLElement ? items.indexOf(active) : -1;
  const to =
    at === -1
      ? key === 'ArrowUp' || key === 'End'
        ? items.length - 1
        : 0
      : nextListboxIndex(at, items.length, key);
  items[to]?.focus();
  return true;
}
